import { http } from './config';

const VENDEDOR_PATH = 'proposal-seller';

export default {
  get: ({ code }) => http.get(`${VENDEDOR_PATH}/${code}`),

  listar: ({ page }) => http.get(`${VENDEDOR_PATH}?page=${page}`),

  salvar: vendedor => http.post(VENDEDOR_PATH, vendedor),

  atualizar: vendedor =>
    http.post(`${VENDEDOR_PATH}/${vendedor._id}`, vendedor),

  deletar: vendedor => http.delete(`${VENDEDOR_PATH}/${vendedor._id}`)
};
